<template lang="html">
  <layout-public>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form v-if="validToken">
              <v-card class="elevation-12" fill-height>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Set Password</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    :error-messages="messages.email"
                    v-model="emailAddress"
                    prepend-icon="fa-envelope"
                    label="Email"
                    type="text"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    :error-messages="messages.password"
                    v-model="password"
                    label="New Password"
                    required
                    :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showInput ? 'text' : 'password'"
                    @click:append="toggleInputVisibility"
                    prepend-icon="fa-lock"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn v-if="loading" loading></v-btn>
                  <v-btn
                    v-else
                    color="primary"
                    class="mb-4 mr-3 add-course-button"
                    @click="reset"
                    >Set Password</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </layout-public>
</template>

<script>
import LayoutPublic from '@/layouts/Public';
import authAPI from '@/api/auth.js';
export default {
  name: 'PasswordSet',
  components: {
    LayoutPublic,
  },
  data() {
    return {
      token: '',
      password: '',
      valid: true,
      messages: {
        email: [],
        password: [],
        error: [],
        loading: false,
      },
      validToken: this.$route.query.isResetPassword == 0 ? true : false,
      showInput: false,
      emailAddress: ''
    };
  },
  computed: {
    email: function () {
      return this.$route.query.email;
    },
    resetToken: function () {
      return this.$route.query.token;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.checkResetPasswordToken();
    });
  },
  methods: {
    reset: function () {
      this.loading = true;
      let resetPassword = 1;
      if (this.$route.query.isResetPassword == 0) {
        resetPassword = 0;
      }
      authAPI
        .resetPassword(
          this.emailAddress,
          this.password,
          this.resetToken,
          resetPassword
        )
        .then(() => {
          this.$snotify.success('Your password has been set successfully.');
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.getProfile();
          this.loading = false;
          this.$router.push('/login');
        })
        .catch((err) => {
          this.loading = false;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.$snotify.error(errMsg);
          }
          this.messages = this.$gf.errorResponse(err);
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 1:
              this.$router.push('/super-admin/companies');
              break;
            case 2:
                 this.$router.push('/admin/users');
              break;
            case 4:
              this.$router.push('partner/users');
              break;
            case 5:
              this.$router.push('partner/users');
              break;
            case 6:
              this.$router.push('/super-admin/billinglist');
              break;
            case 7:
              this.$router.push('/courses');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    checkResetPasswordToken() {
      authAPI
        .checkResetPasswordToken(this.email, this.resetToken)
        .then((response) => {
          this.validToken = true;
          this.emailAddress = response.data.email;
        })
        .catch((err) => {
          this.validToken = false;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.$snotify.error(errMsg);
            if (err.response.status == 422) {
              this.validToken = true;
            } else {
              this.validToken = false;
              this.$router.push('/login');
            }
          }
          this.messages = this.$gf.errorResponse(err);
        });
    },
    toggleInputVisibility() {
      this.showInput = !this.showInput;
    },
  },
};
</script>
